const positions = {
  ctor: 'CON',
  goalkeeper: 'GK',
  guard_point: 'PG',
  guard_shooting: 'SG',
  forward_power: 'PF',
  forward_small: 'SF',
  center: 'C',
  core: 'COR',
  support: 'SUP',
  age1: '1YR',
  age2: '2YR',
  age3: '3YR',
  age4: '4YR',
  age5: '5YR',
  age6: '6YR',
  male_lead: '(M) L',
  male_second: '(M) 2',
  male_vice_skip: '(M) V',
  male_skip: '(M) S',
  female_lead: '(F) L',
  female_second: '(F) 2',
  female_vice_skip: '(F) V',
  female_skip: '(F) S',
  forward_front: 'FF',
  forward_second: '2F',
  forward_back: 'BF',
  half_scrum: 'SH',
  half_fly: 'SF',
  back_outside: 'OB',
  tier1: 'tier1',
  tier2: 'tier2',
  tier3: 'tier3',
  tier4: 'tier4',
  tier5: 'tier5',
}

export default positions;
